var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_3740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7023 7.01784C17.6402 7.01784 19.2112 5.44684 19.2112 3.50892C19.2112 1.571 17.6402 0 15.7023 0C13.7644 0 12.1934 1.571 12.1934 3.50892C12.1934 5.44684 13.7644 7.01784 15.7023 7.01784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7028 30C16.8654 30 17.8079 29.0575 17.8079 27.8949C17.8079 26.7323 16.8654 25.7898 15.7028 25.7898C14.5402 25.7898 13.5977 26.7323 13.5977 27.8949C13.5977 29.0575 14.5402 30 15.7028 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08208 10.2377C8.82634 10.2377 10.2403 8.82365 10.2403 7.0794C10.2403 5.33514 8.82634 3.92114 7.08208 3.92114C5.33783 3.92114 3.92383 5.33514 3.92383 7.0794C3.92383 8.82365 5.33783 10.2377 7.08208 10.2377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3248 26.0765C25.2937 26.0765 26.0792 25.291 26.0792 24.3221C26.0792 23.3531 25.2937 22.5676 24.3248 22.5676C23.3558 22.5676 22.5703 23.3531 22.5703 24.3221C22.5703 25.291 23.3558 26.0765 24.3248 26.0765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50958 18.5089C5.05954 18.5089 6.31603 17.2524 6.31603 15.7024C6.31603 14.1525 5.05954 12.896 3.50958 12.896C1.95962 12.896 0.703125 14.1525 0.703125 15.7024C0.703125 17.2524 1.95962 18.5089 3.50958 18.5089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8948 17.1039C28.6695 17.1039 29.2975 16.4759 29.2975 15.7012C29.2975 14.9266 28.6695 14.2986 27.8948 14.2986C27.1202 14.2986 26.4922 14.9266 26.4922 15.7012C26.4922 16.4759 27.1202 17.1039 27.8948 17.1039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34483 22.5881C4.38506 23.5479 4.38506 25.1008 5.34483 26.0606C6.30346 27.0204 7.85868 27.0204 8.81732 26.0606C9.77709 25.1008 9.77709 23.5479 8.81732 22.5881C7.85868 21.6272 6.3046 21.6181 5.34483 22.5881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3235 8.13133C24.9045 8.13133 25.3755 7.66034 25.3755 7.07934C25.3755 6.49834 24.9045 6.02734 24.3235 6.02734C23.7425 6.02734 23.2715 6.49834 23.2715 7.07934C23.2715 7.66034 23.7425 8.13133 24.3235 8.13133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_3740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9989,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.65e0656750d1fcaf1fe6c6b6cb39cb70.svg";
export { ForwardRef as ReactComponent };